// extracted by mini-css-extract-plugin
module.exports = {"post":"post-module--post--3ESLj","title":"post-module--title--hTIc5","date":"post-module--date--2uDW8","text":"post-module--text--2L7KR"};